const APP_NAME     = 'AirInuit';
const DATA_API_KEY = '.data-api';

const html     = document.documentElement;
const body     = document.body;
const isDebug  = html.hasAttribute('data-debug');
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

export { APP_NAME, DATA_API_KEY, html, body, isDebug, isMobile };
